import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import { thirdMode } from '@/utils/index.js'
import home from '@/views/home'
import mine from '@/views/mine'
import search from '@/components/search'
import list from '@/components/list'
import playVideo from '@/components/playVideo'
import searchList from '@/components/searchList'
import playLink from '@/components/playLink'
import find from '@/views/find/find'
Vue.use(Router)

const router = new Router({
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/vendor',
    name: 'vendor',
    component: () => import('@/views/vendor')
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/rank',
    name: 'rank-page-view',
    component: () => import('@/views/rank')
  },
  {
    path: '/find',
    name: 'find',
    component: find,
    children: [
      {
        path: 'artist',
        name: 'artist',
        component: () => import('@/views/find/artist')
      },
      {
        path: 'rank',
        name: 'rank',
        component: () => import('@/views/find/rank')
      },
      {
        path: 'tags',
        name: 'tags',
        component: () => import('@/views/find/tags')
      }
    ]
  },
  {
    path: '/artist-details',
    name: 'artist-details',
    component: () => import('@/views/find/artist-details')
  },
  {
    path: '/mine',
    name: 'mine',
    component: mine
  }, {
    path: '/search',
    name: 'search',
    component: search
  }, {
    path: '/list',
    name: 'list',
    component: list,
    props: { showNav: true, layout: 'grid' }
  }, {
    path: '/playVideo',
    name: 'playVideo',
    component: playVideo
  }, {
    path: '/searchList',
    name: 'searchList',
    component: searchList
  }, {
    path: '/playLink',
    name: '/playLink',
    component: playLink
  }
  ]
})

router.beforeEach((to, from, next) => {
  const TOKEN = store.state.token ? store.state.token : ''
  const loginPage = 'vendor'
  if (to.name !== loginPage && TOKEN === '' && thirdMode) next({ name: loginPage })
  else next()
})

router.afterEach((to, from, next) => {
  const contentUrl = to.path
  const refererUrl = from.path
  if (refererUrl !== contentUrl && contentUrl !== '/playLink' && window._hmt) {
    window._hmt.push(['_trackPageview', `/#${contentUrl}`])
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js